import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';
import PaycodeConfirmOverlay from '../../components/codes/PaycodeConfirmOverlay';
import PaycodeDeleteConfirmOverlay from '../../components/codes/PaycodeDeleteConfirmOverlay';
import { deletePaycode, getOrgPaycodes, getPaycodeById } from '~/apps/sender/actions/paycodes';
import { defaultTablePageSize } from '~/common/components/consts';
import Loader from '~/common/components/Loader';
import { sendMessageEmail, sendMessageSMS } from '~/apps/sender/actions/message';

class ConfirmPaycodePopup extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      deleteConfirm: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPaycodeById(this.props.paycodeId));
  }

  onEditPaycode = (code) => {
    navigate('sender.paycodes.edit', { paycodeId: code.id });
  };

  // Deletion
  delConfirmOpen = (code) => {
    this.setState({ deleteConfirm: true });
  };

  delConfirmClose = (code) => {
    this.setState({ deleteConfirm: false });
  };

  deletePaycode = (code) => {
    const { dispatch, auth, paycodeId } = this.props;
    const orgId = auth.currentUser.organizationId;

    return dispatch(deletePaycode(paycodeId))
      .then(() => {
        dispatch(getOrgPaycodes(orgId, null, 0, defaultTablePageSize));
        navigate('sender.paycodes');
      });
  };

  onClose = () => {
    navigate('sender.paycodes');
  };

  handleButtonAction = (action, options) => {
    switch (action) {
      case 'request-sms':
        if (options && options.paycode && options.phone) {
          sendMessageSMS(options);
        }
        break;
      case 'request-email':
        if (options && options.paycode && options.email) {
          sendMessageEmail(options);
        }
        break;
      default:
        console.warn(`Not button action: ${action} !!!`);
    }
  };

  render() {
    const { paycodes, paycodeId, organizations, title } = this.props;
    const paycode = paycodes.entities[paycodeId];
    const organization = paycode && organizations.entities[paycode.organizationId];

    if (!paycode || paycodes.ui.loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    if (this.state.deleteConfirm) {
      return (
        <PaycodeDeleteConfirmOverlay
          headTitle={title}
          onDelete={this.deletePaycode}
          onClose={this.delConfirmClose}
          paycode={paycode}
        />
      );
    }

    return (
      <PaycodeConfirmOverlay
        headTitle={title}
        onEdit={this.onEditPaycode}
        onDelete={this.delConfirmOpen}
        onClose={this.onClose}
        handleActions={this.handleButtonAction}
        paycode={paycode}
        organization={organization}
        result={{}}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.shared.auth,
    organizations: state.shared.organizations,
    paycodes: state.sender.paycodes
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPaycodePopup) as any;
